import axios from 'axios';
import store from '@/store';

export default axios.create(store.getters['Config/getAxiosConfig']);
